export const VALIDATOR_CONSTANTS = {
    MOBILE: /^([6-9]){1}[0-9]{9}$/,
    EMAIL: /^([\-A-Za-z0-9_\.])+\@([\-A-Za-z0-9_])+([\.]{1})([A-Za-z]{2,4})$/,
    PIN_CODE: /^\d{6}$/,
    AADHAAR: /\d{4}\s\d{4}\s\d{4}$/,
    PAN: /([A-Z]){5}([0-9]){4}([A-Z]){1}$/,
    REQUIRED: 'required',
    OTP: /^\d{4}$/,
}